import * as React from "react";
import type { SVGProps } from "react";
const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clock_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M15.01 16.05c-.26 0-.52-.1-.71-.3l-3.01-3.05A.98.98 0 0 1 11 12V6.48c0-.55.45-1 1-1s1 .45 1 1v5.11l2.73 2.76c.39.39.38 1.03 0 1.41-.2.19-.45.29-.7.29z" />
    </g>
    <defs>
      <clipPath id="clock_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClock;
